// @ts-check

import { createWidget } from "@opendash/core";



export default createWidget({
  type: "opendash-widget-bcm-scheduler",
  meta: {},
  displayComponent: () => import("./component"),

  settingsComponent: null,

  presets: [
    {
      label: "bcm:widgets.scheduler.name",
      description: "bcm:widgets.scheduler.description",
      imageLink: require("./screenshot.png"),
      layout: [12, 8],
      widget: {
        config: {},
      },
    },
  ],
});
